module.exports = __webpack_public_path__ + "static/media/new-capa2.c6e1373d.png";